import Advanced from "./advanced";

export default Advanced;